module.exports = __webpack_public_path__ + "img/znyy-3-sm.6a58adae.jpg";